import { Component, inject } from '@angular/core';
import { FormControl, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { IceCheckboxComponent } from '@app/shared/components/molecules/ice-checkbox/ice-checkbox.component';

@Component({
  selector: 'app-assessment-step',
  imports: [IceCheckboxComponent, ReactiveFormsModule],
  templateUrl: './assessment-step.component.html',
  styleUrl: './assessment-step.component.scss',
})
export class AssessmentStepComponent {
  private formGroupDirective = inject(FormGroupDirective);

  get isCustomerInformed(): FormControl {
    return this.formGroupDirective.form?.controls?.isCustomerInformed as FormControl;
  }
}
